module.exports = __webpack_public_path__ + "assets/img/logo-frame.f9da8e60.png";